export const PRODUCTS = [
  { name: "Powdered Milk", link: "/productpage3" },
  { name: "Condensed Milk", link: "/productpage2" },
  { name: "Evaporated Milk", link: "/productpage1" },
];
export const RESOURCES = [
  { name: "Industries and tools", link: "#" },
  { name: "Use cases", link: "#" },
  { name: "Blog", link: "#" },
  { name: "Online evenet", link: "#" },
  { name: "Nostrud exercitation", link: "#" },
];
export const COMPANY = [
  { name: "Home", link: "/" },
  { name: "About us", link: "/Aboutus" },
  { name: "Contact", link: "/contactus" },
  { name: "Product Page", link: "/productpage" },

];
export const SUPPORT = [
  { name: "P.O Box : 3309, Al Ras, Dubai, U.A.E", link: "#" },
  { name: "Call us: +971 4 226 2661", link: "#" },
  { name: "info@safaglobal.com", link: "#" },
 
];

export const Icons = [
  { name: "logo-facebook", link: "https://www.facebook.com/hilwamilkpowder/",color:'blue' },
  { name: "logo-youtube", link: "https://www.youtube.com/@hilwamilk",color:'red' },

];
